/* unplugin-vue-components disabled */import script from "./BreadCrumb.vue?vue&type=script&lang=ts&setup=true"
export * from "./BreadCrumb.vue?vue&type=script&lang=ts&setup=true"

import "./BreadCrumb.vue?vue&type=style&index=0&id=851c3676&lang=scss&rel=stylesheet%2Fscss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-851c3676"]])

export default __exports__